export function isJobHidden(job: { applicationState?: string | null; isHidden?: boolean }): boolean {
  return job.isHidden === true || job.applicationState === 'hidden';
}
